<template>
  <div class="brand-review-wrapper" v-if="letterObject">
    <div class="box brand-review" :class="isNew ? 'new-brand-review' : ''">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteRecommendationLetter(letterObject.id)" v-if="!isNew"/>
      <b-field label="Заголовок">
        <b-input v-model='letterObject.title'></b-input>
      </b-field>
      <b-switch v-model='letterObject.isHidden'>Скрыть с сайта</b-switch> <br>
      <div class="link-wrapper" v-if="letterObject.file || file">
        <a class="link mt-10" :href="'/' + letterObject.file" target="_blank">Просмотреть файл</a>
        <span class="delete-file" @click="deleteFile">x</span>
      </div>
      <b-field v-else class="mt-10">
        <button 
          @click="$refs.loadFile.click()"
          class="button mt-10">
          Загрузить файл
        </button> <br>
        <input type="file" ref="loadFile" hidden @change='loadFile'/>
      </b-field>
      <button class="button is-primary mt-10 save-button" @click="save" :disabled="disabled">СОХРАНИТЬ</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import deepcopy from 'deepcopy'

export default {
  name: 'RecommendationLetterItem',
  data () {
    return {
      disabled: false,
      file: '',
      letterObject: null
    }
  },
  props: {
    letter: { }
  },
  created () {
    this.letterObject = deepcopy(this.letter || {
      title: '',
      isHidden: true,
      file: ''
    })
  },
  computed: {
    isNew () {
      return this.$route.name === 'RecommendationLetterCreator'
    }
  },
  methods: {
    ...mapActions(['deleteRecommendationLetter', 'updateRecommendationLetter']),
    save () {
      if (this.letterObject.title) {
        this.disabled = true
        let data = new FormData()
        data.append('data', JSON.stringify(this.letterObject))
        data.append('file', this.file)
        this.updateRecommendationLetter(data)
        .then((data) => {
          this.disabled = false
          this.$router.push({ name: 'BrandRecommendations' })
          this.$toast.open({
            message: 'Сохранено'
          })
          this.letterObject = data
        })
      } else {
        this.$toast.open({
          message: 'Заполните хотя бы одно поле',
          type: 'is-danger'
        })
      }
    },
    deleteFile () {
      this.file = ''
      this.letterObject.file = ''
    },
    loadFile (e) {
      this.file = e.target.files[0]
    }
  }
}
</script>

<style scoped>
.brand-review-wrapper {
  padding: 10px;
}
.brand-review .delete-icon {
  right: 9px;
  top: -13px;
}
.save-button {
  display: block;
  margin: 0 auto;
}
.link.mt-10 {
  display: inline-block;
}
.delete-file {
  cursor: pointer;
  color: gray;
}
.new-brand-review {
  max-width: 760px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// RecommendationLetterItem.vue?41590633